/**
 * InsightStatusBadge — renders the live status pill for an insight or
 * recommendation. The actual status is computed by the caller using
 * `computeInsightStatus()` so we never mislabel an issue as "Resolved"
 * when a user merely clicked a button.
 */
import React from 'react';
import { Badge } from '../../../../components/ui/badge';
import { INSIGHT_STATUSES } from '../DistributionDemoContext';

const TONE_CLASSES = {
    rose:    'bg-rose-50 text-rose-700 border-rose-200',
    indigo:  'bg-indigo-50 text-indigo-700 border-indigo-200',
    slate:   'bg-slate-50 text-slate-700 border-slate-200',
    amber:   'bg-amber-50 text-amber-700 border-amber-200',
    emerald: 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

export default function InsightStatusBadge({ status, testid }) {
    const meta = INSIGHT_STATUSES[status] || INSIGHT_STATUSES.detected;
    const tone = TONE_CLASSES[meta.tone] || TONE_CLASSES.slate;
    return (
        <Badge
            data-testid={testid}
            variant="outline"
            className={`${tone} border text-[10px] uppercase tracking-wider font-semibold`}
        >
            {meta.label}
        </Badge>
    );
}
